import _ from "lodash";

export const wordingScenarios = [
  {
    label: "快速评论",
    value: "quick_comment",
  },
  {
    label: "删帖",
    value: "delete_post",
  },
  {
    label: "隐藏帖",
    value: "hide_post",
  },
  {
    label: "删评论",
    value: "delete_comment",
  },
  {
    label: "封禁用户",
    value: "ban_user",
  },
  {
    label: "拒绝帖子",
    value: "reject_post",
  },
  {
    label: "项目下架",
    value: "unpublish_project",
  },
];

export const wordingScenariosMap = _.fromPairs(
  wordingScenarios.map((item) => [item.value, item.label])
);

export const wordingScenariosColorMap = {
  quick_comment: "blue",
  delete_post: "red",
  hide_post: "orange",
  delete_comment: "red",
  ban_user: "red",
  reject_post: "orange",
  unpublish_project: "red",
};
